import mutations from './doctorMagisTemplate.mutations'
import actions from './doctorMagisTemplate.actions'
import getters from './doctorMagisTemplate.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
